import tokens from '@/styles/tokens';
import styled from 'vue3-styled-components';
import { rem } from 'polished';
import { props } from './box.shared';

export const StBox = styled('div', props)`
  padding: ${ ({size}) => size === 'md' ? rem(24) : rem(15) };
  background-color: ${ () => tokens.colors.gray['50'] };
`;
